<template>
  <div class="container-fluid">
    <div class="row container-showcase align-start justify-space-between">
      <!--      player-->
      <v-col
        cols="12"
        class="wow fadeInLeftBig col-lg-7 col-xl-7 player"
        style="position: relative"
      >
        <player
          :poster-url="ctnShowcase.url_poster"
          :is-control-scene="true"
          :video-plr="video"
          @nextScene="onNextMainScene"
          @preScene="onPreMainScene"
        >
          <template v-slot:ads>
            <div v-for="(shop, idxShop) in shops" :key="idxShop">
              <transition name="slide-fade">
                <div
                  v-if="
                    (shop.config && !shop.config.duration) ||
                    shop.timeNow - shop.timeStart < shop.config.duration
                  "
                  :style="getPositionBanner(shop)"
                >
                  <div
                    @click.stop="nexToDetailPage(shop.url)"
                    style="position: relative; cursor: pointer"
                    class="wow slideInLeft"
                  >
                    <img :src="shop.image" v-if="shop.config.type !== 2" />
                    <video
                      class="video-ads"
                      autoplay
                      muted
                      @ended="handleEndVideo(idxShop)"
                      :src="shop.image"
                      v-else
                    ></video>
                    <v-icon
                      style="
                        position: absolute;
                        top: 4px;
                        right: 4px;
                        z-index: 999;
                      "
                      color="white"
                      @click.stop="handleEndVideo(idxShop)"
                      >{{ mdiClose }}</v-icon
                    >
                    <small
                      v-if="shop.config.type !== 2"
                      style="
                        position: absolute;
                        bottom: 4px;
                        right: 4px;
                        z-index: 999;
                        color: white;
                      "
                      >{{
                        shop.config.duration - (shop.timeNow - shop.timeStart)
                      }}(s)</small
                    >
                  </div>
                </div>
              </transition>
              <!--        top left-->
            </div>
          </template>
        </player>
        <content-same-showcase
          :title="ctnShowcase.title"
          :type-show-case="Number(ctnShowcase.type_showcase)"
          :showcase-id="ctnShowcase.showcase_id"
          @selectContent="handleChangeContent"
        />
      </v-col>
      <v-col
        cols="12"
        class="col-xl-5 col-lg-5 mt-lg-0 mt-md-12 mt-sm-12 mt-xs-12"
      >
        <div class="title-demo">
          <h5>Demo {{ $t("contextual_advertising_title") }}</h5>
          <span>
            {{ $t("contextual_advertising_des") }}
          </span>
        </div>
      </v-col>
    </div>
  </div>
</template>

<script>
import Player from "./components/Player";
import ContentSameShowcase from "./components/ContentSameShowcase";
import { playerShowcase } from "../../minxin/player-showcase";
import _ from "lodash";
import { mdiClose } from "@mdi/js";
export default {
  name: "ContextualAdvertising",
  mixins: [playerShowcase],
  data() {
    return {
      mdiClose: mdiClose,
    };
  },
  components: { Player, ContentSameShowcase },
  methods: {
    getPositionBanner(shop) {
      switch (shop.config.pos) {
        case "top-left":
          return {
            position: "absolute",
            top: "2px",
            left: "2px",
            width: shop.config.ratio * 100 + "%",
          };
        case "top-right":
          return {
            position: "absolute",
            top: "2px",
            right: "2px",
            width: shop.config.ratio * 100 + "%",
          };
        case "bottom-right":
          return {
            position: "absolute",
            bottom: "2px",
            right: "2px",
            width: shop.config.ratio * 100 + "%",
          };
        case "bottom-left":
          return {
            position: "absolute",
            bottom: "2px",
            left: "2px",
            width: shop.config.ratio * 100 + "%",
          };
        case "center-center":
          return {
            position: "absolute",
            width: shop.config.ratio * 100 + "%",
            height: shop.config.ratio * 100 + "%",
            left: ((1 - shop.config.ratio) / 2) * 100 + "%",
            top: ((1 - shop.config.ratio) / 2) * 100 + "%",
          };
        case "top-center":
          return {
            position: "absolute",
            top: "2px",
            width: shop.config.ratio * 100 + "%",
            left: ((1 - shop.config.ratio) / 2) * 100 + "%",
          };
        case "bottom-center":
          return {
            position: "absolute",
            bottom: "2px",
            width: shop.config.ratio * 100 + "%",
            left: ((1 - shop.config.ratio) / 2) * 100 + "%",
          };
        default:
          return {
            position: "absolute",
            bottom: "2px",
            right: "2px",
            width: shop.config.ratio * 100 + "%",
          };
      }
    },
    getCurrentMetaWithPos() {
      /*
       * Get meta data tại thời điểm video hiện tại
       * */
      let res = [];
      if (this.timePlay) {
        const messages = this._getMetaDataInTime(
          this.showcaseCr.data,
          this.timePlay
        );
        for (let message of messages) {
          res.push(message);
        }
      }
      return res;
    },
    _addEventTimeUpdateAndFullScreen(video) {
      const updateAdsPosition = () => {
        const messages = this.getCurrentMetaWithPos();
        let index = 0;
        for (let oldShop of this.shops) {
          let updateShop = _.find(messages, { id: oldShop.id });
          if (updateShop) {
            oldShop.timeNow = Math.round(new Date().getTime() / 1000);
            _.remove(messages, { id: oldShop.id });
            // oldShop.show = true;
          } else {
            this.shops.splice(index, 1);
            // oldShop.show = false;
          }
          index += 1;
        }
        for (const message of messages) {
          const infoShop = _.find(this.showcaseCr.metadata, {
            id: message.id,
          });
          if (!infoShop) {
            continue;
          }
          if (infoShop && message.config) {
            infoShop.config = {
              ...infoShop.config,
              ...message.config,
            };
          }
          const newShop = {
            timeStart: Math.round(new Date().getTime() / 1000),
            timeNow: Math.round(new Date().getTime() / 1000),
            ...infoShop,
          };
          this.shops.push(newShop);
        }
      };
      video.addEventListener("timeupdate", () => {
        this.timePlay = this.video.currentTime;
        updateAdsPosition();
      });
      video.addEventListener("fullscreenchange", () => {
        updateAdsPosition();
      });
      return video;
    },
    handleEndVideo(idShop) {
      if (idShop < this.shops.length) {
        this.shops[idShop].timeStart = 0;
        this.shops[idShop].config.duration = -1;
      }
    },
    nexToDetailPage(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
.banner-tvc {
}
.video-ads {
}
</style>
